module.exports = __webpack_public_path__ + "img/levelup_platinum_notcompleted.0d8f627c.svg";